/* 夏侯淵傳・第 5 章：枹罕・虎步關右（建安十九年冬十月，214）
 * 史實：《三國志·夏侯淵傳》「初，枹罕宋建因涼州亂，自號河首平漢王。太祖使淵帥諸將討建。淵至，圍枹罕，月餘拔之，斬建及所置丞相已下。
 *       淵别遣張郃等平河關，渡河入小湟中，河西諸羌盡降，隴右平。」太祖下令：「宋建造爲亂逆三十餘年，淵一舉滅之，虎步關右，所向無前。」
 *       《武帝紀》：宋建「聚衆枹罕，改元，置百官，三十餘年。遣夏侯淵自興國討之。冬十月，屠枹罕，斬建，涼州平。」
 * 流程：1. 圍城：城中存糧慢慢減；開著的城門會出擊。在四座城門外站定立「圍營」，那座門就堵住；堵得越多，存糧掉得越快。張郃跟著夏侯淵。
 *       2. 存糧歸零，城中大亂，東門被打開：入城斬宋建所置的丞相與宋建。
 *       3. 結局三張卡：平河關、隴右平；曹操令「虎步關右」；定軍山（接曹操傳第 12 章）與曹操生前的告誡。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, TROOPS } from '../kit.ts';
import { XHY, XTROOPS, F, campDraw } from './xiahouyuan_kit.ts';
import { CITY, GATES, SIEGE, START } from '../maps/xiahouyuan_fuhan.ts';

const LV = 13, DAY = 3, SORTIE = 14;
const NAMES = { e: '東門', n: '北門', s: '南門', w: '西門' };
const MEN = F(XTROOPS.qiang, '枹罕兵', 460, 24, 245), HUNGRY = F(XTROOPS.qiang, '枹罕兵', 300, 16, 220);

export default {
  id: 'xiahouyuan-5', map: 'xiahouyuan_fuhan', hero: 'xiahouyuan',
  title: '第 5 章　枹罕・虎步關右', year: '建安十九年（214）',
  brief: {
    quote: [{ text: '宋建造爲亂逆三十餘年，淵一舉滅之，虎步關右，所向無前。', src: '《三國志·魏書·夏侯淵傳》' }],
    text: '隴西的宋建趁涼州大亂，在枹罕自稱河首平漢王，改年號、設百官，已經三十多年。平定興國之後，曹操派夏侯淵率諸將討伐。',
    goals: ['在四座城門外立圍營，堵住出擊、斷絕城中糧食', '存糧耗盡、城破後入城', '斬宋建所置的丞相與宋建'],
  },
  words: { ally: '魏軍', foe: '枹罕兵' },
  stars: [
    { text: '四座城門都立了圍營', ok: (m) => m.vars.sealed >= 4 },
    { text: '月餘拔之：圍城不到 40 天城破', ok: (m) => m.vars.fallDay != null && m.vars.fallDay < 40 },
    { text: '張郃沒有倒下', ok: (m) => !m.vars.zhDown },
  ],
  steps: [
    { // 1. 圍城
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.t0 = w.t; V.food = 100; V.sealed = 0; V.camps = {}; V.sortT = 8;
        V.zh = ally(w, 'zhanghe', START[0] - 150, START[1] + 120, LV);
        V.men = Array.from({ length: 6 }, (_, i) => { const u = m.recruit(me.x - 80 - (i % 3) * 50, me.y - 60 + Math.floor(i / 3) * 100, '魏軍'); u.spec = TROOPS.wei; m.join(u, me); return u; });
        V.garrison = Array.from({ length: 10 }, (_, i) => { const a = (i / 10) * Math.PI * 2; return m.foe('huangjin', CITY.x + Math.cos(a) * 500, CITY.y + Math.sin(a) * 320, MEN); });
        for (const k in SIEGE) m.mark('s' + k, SIEGE[k][0], SIEGE[k][1], NAMES[k] + '外', true);
        m.card('初，枹罕宋建因涼州亂，自號河首平漢王。', '《夏侯淵傳》');
        m.after(5, () => m.line('夏侯淵', '枹罕四門。每座門外立一座營，困死他！'));
        m.after(9, () => m.line('提示', '站在城門外的標記處不動就能立圍營，那座門就堵住了；開著的門會不時出兵。'));
        m.obj('seal', '在城門外立圍營', 4);
        m.obj('food', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        allyTick(w, V.zh, me);
        for (const k in SIEGE) {
          if (V.camps[k]) continue;
          const [x, y] = SIEGE[k];
          m.chanAt(me, 's' + k, x, y, 200, 3, '立圍營', () => {
            V.camps[k] = true; V.sealed++; m.unmark('s' + k);
            m.gate(k, GATES[k][0], GATES[k][1], 190, 'citygate');
            m.folk(x + (k === 'w' ? -60 : 60), y - 20, { name: '圍營', still: true, near: 1, draw: campDraw, col: '#3b5a99', flag: '夏', flagCol: '#3b5a99' });
            m.line('夏侯淵', `${NAMES[k]}堵住了！`);
          });
        }
        // 開著的門出擊
        if ((V.sortT -= dt) <= 0) {
          V.sortT = SORTIE;
          for (const k in GATES) if (!V.camps[k]) {
            const [gx, gy] = GATES[k], ox = Math.sign(gx - CITY.x) * 160, oy = Math.sign(gy - CITY.y) * 120;
            for (let i = 0; i < 2; i++) { const u = m.foe('huangjin', gx + ox + (i ? 50 : -50), gy + oy, MEN); u.home = [me.x, me.y]; }
          }
        }
        V.food = Math.max(0, V.food - (0.1 + 0.3 * V.sealed + (V.sealed >= 4 ? 0.8 : 0)) * dt); // 四門合圍才真正斷糧
        V.day = (w.t - V.t0) / DAY;
        m.prog('seal', V.sealed);
        m.get('food').text = `圍城第 ${Math.floor(V.day)} 天　城中存糧：${Math.round(V.food)}%`;
        return V.food <= 0;
      },
    },
    { // 2. 城破，入城
      enter(m, w) {
        const me = w.player, V = m.vars;
        V.fallDay = V.day; m.done('food'); m.drop('food');
        m.big('城中糧盡，東門開了！');
        m.ungate('e');
        for (const u of m.alive(V.garrison)) { u.hp = Math.min(u.hp, HUNGRY.hp); u.atk = HUNGRY.atk; }
        V.xiang = boss(w, XHY.chengxiang, CITY.x + 250, CITY.y - 120, { name: '丞相', hp: 2600, atk: 36, armor: 6, range: 400, ms: 230 });
        V.jian = boss(w, XHY.songjian, CITY.x - 200, CITY.y + 80, { name: '宋建', hp: 4600, atk: 48, armor: 9, ms: 245 });
        m.mark('jian', V.jian.x, V.jian.y, '宋建', false, V.jian);
        m.obj('kill', '斬宋建及所置丞相', 2);
        m.line('宋建', '我是河首平漢王！三十年了，誰敢進我的城！');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        allyTick(w, V.zh, me);
        m.prog('kill', [V.xiang, V.jian].filter((u) => !u.alive).length);
        return !V.xiang.alive && !V.jian.alive;
      },
    },
    { // 3. 隴右平；結局
      enter(m, w) {
        m.done('kill'); m.unmark('jian');
        m.card('淵至，圍枹罕，月餘拔之，斬建及所置丞相已下。淵别遣張郃等平河關，渡河入小湟中，河西諸羌盡降，隴右平。', '《夏侯淵傳》');
        m.after(7, () => m.card('太祖下令曰：「宋建造爲亂逆三十餘年，淵一舉滅之，虎步關右，所向無前。仲尼有言：『吾與爾不如也。』」', '《夏侯淵傳》'));
        m.after(14, () => m.card('二十四年正月，備夜燒圍鹿角。……淵分所將兵半助郃，爲備所襲，淵遂戰死。（見曹操傳第 12 章）', '《夏侯淵傳》'));
        m.after(21, () => m.card('初，淵雖數戰勝，太祖常戒曰：「爲將當有怯弱時，不可但恃勇也。將當以勇爲本，行之以智計；但知任勇，一匹夫敵耳。」', '《夏侯淵傳》'));
        m.after(28, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (V.zh && !V.zh.alive) V.zhDown = true;
    if (!w.player.alive) m.lose('夏侯淵陣亡');
  },
};
